import React, { Fragment, FunctionComponent } from 'react';
import { Link } from 'gatsby';

import {
  NavbarRoot,
  NavbarLogo,
  NavbarLogoLink,
  NavbarLinks,
  ExternalNavbarLink,
  NavbarRight,
} from './Navbar.style';

interface NavbarProps {
  overlay?: boolean;
  showLogo?: boolean;
}

const helfyWebsite = 'https://helfy.uk';

const Navbar: FunctionComponent<NavbarProps> = ({
  overlay = false,
  showLogo = true,
}) => (
  <NavbarRoot overlay={overlay}>
    <NavbarLinks>
      <ExternalNavbarLink href={`${helfyWebsite}/#how`}>
        How it works
      </ExternalNavbarLink>
      <ExternalNavbarLink href={`${helfyWebsite}/menu`}>
        Menu
      </ExternalNavbarLink>
      <ExternalNavbarLink href={`${helfyWebsite}/#why`} hideOnMobile>
        Why helfy
      </ExternalNavbarLink>
      <ExternalNavbarLink href={`${helfyWebsite}/gift-cards`} hideOnMobile>
        Gift cards
      </ExternalNavbarLink>
      <ExternalNavbarLink href={`${helfyWebsite}/help`} hideOnMobile>
        Help
      </ExternalNavbarLink>
    </NavbarLinks>
    {showLogo && (
      <Fragment>
        <NavbarLogoLink to="/" aria-label="Helfy blog">
          <NavbarLogo kind="wordmark" height={28} title="Helfy" />
        </NavbarLogoLink>
        <NavbarRight />
      </Fragment>
    )}
  </NavbarRoot>
);

export default Navbar;
